import * as React from "react";
const SvgEcsysPulse = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 12h4l2.5-7 4 14L16 12h5" }));
export default SvgEcsysPulse;
